import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    description: Yup.string().required('tracker.logMeal.input.validationError.empty'),
    baseAmount: Yup.number()
      .min(0.1, 'tracker.logMeal.ingredients.validationError.accetableValue')
      .max(5000, 'tracker.logMeal.ingredients.validationError.accetableValue')
      .required('tracker.logMeal.input.validationError.empty'),
  });
};

export default validationSchema;
